<template>
  <div id="nothilfe-app" class="oeamtc">
    <div class="landing" :data-version="version">
      <oeamtc-loader
        :large="true"
        :horizontal="true"
        slotContent="Lade..."
        v-if="
          optionsLoading || livestatusLoading || userLoading || vehiclesLoading
        "
      >
        Lade...
      </oeamtc-loader>
      <template v-else>
        <p class="opening-text" v-if="showCauseSelector && !showChat">
          Hier können Sie die ÖAMTC Pannenhilfe online anfordern. Wählen Sie
          zuerst die Ursache Ihrer Panne:
        </p>
        <oeamtc-dropdown
          id="request-type"
          :value="causeType"
          :v-model="causeType"
          @input="selectChanged"
          v-if="showCauseSelector && !showChat"
          class="request-type-dropdown"
        >
          <template slot="placeholder">
            <option value="" selected="" disabled="">
              Bitte wählen Sie eine Option
            </option>
          </template>
          <template slot="options">
            <option
              v-for="option in options"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </template>
        </oeamtc-dropdown>
        <CallOnly v-if="callOnly"></CallOnly>
        <RequestForm
          v-if="showForm"
          :selectedCause="selectedCause"
          :user="user"
          :vehicles="vehicles"
          @submitted="formSubmitted"
        ></RequestForm>
        <ChatMessages
          v-if="showChat && foundLivestatus"
          :livestatus="foundLivestatus"
        ></ChatMessages>
      </template>
    </div>
  </div>
</template>

<script>
import { OeamtcDropdown, OeamtcLoader } from '@oeamtc/styleguide-vuejs-lib-ui';
import CallOnly from '@/components/CallOnly.vue';
import RequestForm from '@/components/Form.vue';
import ChatMessages from '@/components/Chat.vue';
import axios from 'axios';

export default {
  name: 'App',
  components: {
    OeamtcDropdown,
    OeamtcLoader,
    CallOnly,
    RequestForm,
    ChatMessages,
  },
  data() {
    return {
      livestatusLoading: true,
      userLoading: true,
      vehiclesLoading: true,
      options: [],
      optionsLoading: true,
      callOnly: false,
      showCauseSelector: true,
      showForm: false,
      showChat: false,
      causeType: '',
      causes: [],
      selectedCause: null,
      foundLivestatus: null,
      user: null,
      vehicles: null,
      version: process.env.VUE_APP_VERSION,
    };
  },
  methods: {
    selectChanged(cause) {
      if (cause) {
        this.resetState();
        this.causeType = cause;
        this.selectedCause = this.causes.find((c) => c.title === cause);
        if (this.selectedCause.call_method === 'msg') {
          this.showForm = true;
        } else {
          this.callOnly = true;
        }
      }
    },
    resetState() {
      this.causeId = null;
      this.callOnly = false;
      this.showForm = false;
    },
    formSubmitted(response) {
      this.showForm = false;
      this.showChat = true;
      this.foundLivestatus = response.Livestatus;
      this.scrollToTop();
    },
    scrollToTop() {
      const element = window.document.getElementById('nothilfe-app');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
    getCauses() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/msg/assistance/config_v3`)
        .then((response) => {
          this.optionsLoading = false;
          this.causes = response.data.call_causes;
          this.options = response.data.call_causes.map((cause) => {
            return {
              value: cause.title,
              label: cause.title,
            };
          });
        });
    },
    findLivestatus() {
      const token = this.getParameterByName('token');
      if (token) {
        axios
          .get(
            `${process.env.VUE_APP_API_URL}/msg/assistance/find_livestatus?token=${token}`
          )
          .then(
            (response) => {
              this.showChat = true;
              this.foundLivestatus = response.data.Livestatus;
              this.livestatusLoading = false;
            },
            (error) => {
              console.error('Livestatus error: ', error);
              this.livestatusLoading = false;
            }
          );
      } else {
        if (process.env.NODE_ENV === 'development') {
          axios
            .get(
              `${process.env.VUE_APP_API_URL}/msg/assistance/find_livestatus`
            )
            .then(
              (response) => {
                this.showChat = true;
                this.foundLivestatus = response.data.Livestatus;
                this.livestatusLoading = false;
              },
              (error) => {
                console.error('Livestatus error: ', error);
                this.livestatusLoading = false;
              }
            );
        } else {
          axios
            .get(
              `${process.env.VUE_APP_API_URL}/msg/assistance/find_livestatus`,
              {
                headers: {
                  withCredentials: true,
                },
              }
            )
            .then(
              (response) => {
                this.showChat = true;
                this.foundLivestatus = response.data.Livestatus;
                this.livestatusLoading = false;
              },
              (error) => {
                console.error('Livestatus error: ', error);
                this.livestatusLoading = false;
              }
            );
        }
      }
    },
    getParameterByName(name, url = window.location.href) {
      name = name.replace(/[[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    loadUserData() {
      if (process.env.NODE_ENV === 'development') {
        axios
          .get(
            `${process.env.VUE_APP_API_URL}/msg/user/v3?info=true&vehicles_v2=true`
          )
          .then(
            (response) => {
              this.userLoading = false;
              this.user = response.data.user;
            },
            (error) => {
              console.error('get user error: ', error);
              this.userLoading = false;
            }
          );
      } else {
        axios
          .get(
            `${process.env.VUE_APP_API_URL}/msg/user/v3?info=true&vehicles_v2=true`,
            {
              headers: {
                withCredentials: true,
              },
            }
          )
          .then(
            (response) => {
              this.userLoading = false;
              this.user = response.data.user;
            },
            (error) => {
              console.error('get user error: ', error);
              this.userLoading = false;
            }
          );
      }
    },
    loadVehicles() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/msg/masterdata/vehicles/makes`)
        .then(
          (response) => {
            this.vehicles = response.data.vehicle_makes;
            this.vehiclesLoading = false;
          },
          (error) => {
            console.error('get vehicle makes: ', error);
          }
        );
    },
  },
  beforeMount() {
    this.getCauses();
    this.findLivestatus();
    this.loadUserData();
    this.loadVehicles();
  },
};
</script>

<style lang="scss">
.oeamtc-field__label[for='request-type'] {
  white-space: normal;
  height: auto;
  line-height: 1.5;
  margin-bottom: 0.5rem;
}

.request-type-dropdown {
  label.oeamtc-field__label {
    height: 0;
  }
}
</style>
